import { render } from "./Loading.vue?vue&type=template&id=0d15bdcc&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=0d15bdcc&scoped=true&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.9.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d15bdcc"]])

export default __exports__